
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gy3YMuoqDsJTNwgoaBpr3F7p5vI4yHeW5BnceOzpGV2cMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexFjfSr6ec05HutFUKvacXfxurmtntywR7_45hAh77EhFeMMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchydsHXymbVJB6F4aI5xvSzqreZUk6EDkS01t4gjaPRSoMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexgobktodx7OWAB3r0t_45XxCtPpyIWBCmzqFVjjHmp8gcgMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_937ilWQbMQ9L6yZ0WXwXa41cqAMOeT_459Q1cmIFSR58mQYMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexNkf2K0nhUMghPJZBg6OJkpnNGqPscpKoO6X6cMI0d5cMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93k4Hba7u7NoYGBy9ZKrsgVk9wMEAzGxp0VaZhGfcM_4IMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index1GzYiort0Le_mhGcWBVQGfHkmgwgKA8FVbE3pC6HUx0Meta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93H2X7e8WJxtCgCnQmB_45WaNlEEcbDUEurdGzh_45Fi1yy2wMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexvfZPNMQYcB7JxruINS_91ykmJZhgQuNiGIxaXhT4IisMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexAQJGrf32jQGGQdkzp8uOsUDHuGUFAtOaLyplktxTeHEMeta } from "/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexNkf2K0nhUMghPJZBg6OJkpnNGqPscpKoO6X6cMI0d5cMeta || {},
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index1GzYiort0Le_mhGcWBVQGfHkmgwgKA8FVbE3pC6HUx0Meta || {},
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexvfZPNMQYcB7JxruINS_91ykmJZhgQuNiGIxaXhT4IisMeta || {},
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexAQJGrf32jQGGQdkzp8uOsUDHuGUFAtOaLyplktxTeHEMeta || {},
    component: () => import("/codebuild/output/src1144144622/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]